import { useMemo } from "react"

import { useListIntegrationVendorsWithCatalogs } from "features/api/search"
import { IntegrationVendorLabelMap } from "features/pos/products/CatalogSkus/catalogSku.types"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export const catalogVendorFilterKey = "catalogVendor"

export function useCatalogVendorFilter({
  persistInUrl = true,
  initialSelectedOptions = [],
}: Pick<
  UseWebFilterProps<unknown>,
  "persistInUrl" | "initialSelectedOptions"
> = {}) {
  const { data } = useListIntegrationVendorsWithCatalogs()

  const values = useMemo(
    () =>
      [...(data?.integrationVendors ?? [])].sort((a, b) =>
        IntegrationVendorLabelMap[a].localeCompare(IntegrationVendorLabelMap[b])
      ),
    [data]
  )

  const { filter, selectedKeys } = useWebFilter({
    key: catalogVendorFilterKey,
    label: "Integration vendor",
    values,
    keyExtractor: (v) => v.toString(),
    labelExtractor: (v) => IntegrationVendorLabelMap[v],
    persistInUrl,
    initialSelectedOptions,
  })

  const selectedIntegrationVendors = useMemo(
    () => selectedKeys.map(Number),
    [selectedKeys]
  )

  return { filter, selectedIntegrationVendors }
}
